import { Avatar, type AvatarImageProps, Circle, Float } from '@chakra-ui/react';
import type React from 'react';

interface IAvatarImageProps extends AvatarImageProps {
  children?: React.ReactNode;
  src?: string;
}

const CustomAvatar = {
  Root: (props: React.ComponentProps<typeof Avatar.Root>) => (
    <Avatar.Root {...props} />
  ),
  Fallback: (props: React.ComponentProps<typeof Avatar.Fallback>) => (
    <Avatar.Fallback {...props} />
  ),
  Image: (props: IAvatarImageProps) => <Avatar.Image {...props} />,
};

interface IFaceliftAvatarProps {
  name: string;
  previewUrl?: string;
  colorPalette?: string;
  variant?: "outline" | "subtle" | "solid";
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "full" | "2xs" | "xs"
}

const FaceliftAvatarNoBadge: React.FC<IFaceliftAvatarProps> = ({
  name,
  previewUrl,
  colorPalette = "green",
  variant = "subtle",
  size = "full",
}) => {
  return (
    <CustomAvatar.Root
      size={size}
      colorPalette={colorPalette}
      variant={variant}
    >
      <CustomAvatar.Fallback name={name} />
      {previewUrl && <CustomAvatar.Image src={previewUrl} />}
    </CustomAvatar.Root>
  );
};

export default FaceliftAvatarNoBadge;
